export default __webpack_public_path__ + "pgnv-assets/16f45a4354f120dc857bfa7b3775d2e1.png";